/**
 * Created by lu on 2018/4/9.
 */
var nb = require('../../nb');
module.exports = nb.define({
    parent: nb.Model,
    method: {
        init: function () {
            this.onChange('status', function (inEvent,inStatus) {
               if(inStatus == 'full'){
                   var screenHeight = document.documentElement.clientHeight; //documentElement 属性可返回文档的根节点。 clientHeight 表示元素可以看到内容的可见区域部分
                   this.set('height', screenHeight);   //可见区域高度
               }
            },this);
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/banner/Banner.js
// module id = 523
// module chunks = 6